import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { ApiResponseModel } from '../../shared/api-response.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import {GenericDocApprovalCoversionMonitorContainerModel} from '../../../../../../models/aggregates/erp/generic-approval';

@Injectable({providedIn: 'root'})
export class ConversionMonitorService extends BaseApiTemplateService<GenericDocApprovalCoversionMonitorContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/conversion-monitors/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/conversion-monitors/backoffice-ep';
    this.httpClient = http;
  }

   checkConversion(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      let customUrl;
      if (this.endpoint_path && visa.api_domain_url) {
         this.apiUrl = visa.api_domain_url + this.endpoint_path;
         customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/conversion-monitors/conversion-checking/backoffice-ep';
      }
      return this.httpClient.post<ApiResponseModel<any>>(
        customUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }
}
